import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { LoginPage } from '@/pages/LoginPage'
import { BooksPage } from '@/pages/BooksPage'
import { UploadPage } from '@/pages/UploadPage'
import { BookDetailPage } from '@/pages/BookDetailPage'
import { BookEditPage } from '@/pages/BookEditPage'
import { ThemesPage } from '@/pages/ThemesPage'
import { UserManagementPage } from '@/pages/UserManagementPage'
import { HelpCenterPage } from '@/pages/HelpCenterPage'
import { FeedbackManagementPage } from '@/pages/FeedbackManagementPage'
import { AppReleasesPage } from '@/pages/AppReleasesPage'
import { NotificationsPage } from '@/pages/NotificationsPage'
import { DiscussionsPage } from '@/pages/DiscussionsPage'

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Layout />}>
        <Route path="/" element={<BooksPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/books/:bookId" element={<BookDetailPage />} />
        <Route path="/books/:bookId/edit" element={<BookEditPage />} />
        <Route path="/themes" element={<ThemesPage />} />
        <Route path="/users" element={<UserManagementPage />} />
        <Route path="/apps/releases" element={<AppReleasesPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/discussions" element={<DiscussionsPage />} />
        <Route path="/support/help" element={<HelpCenterPage />} />
        <Route path="/support/feedback" element={<FeedbackManagementPage />} />
        <Route path="/settings" element={<Navigate to="/users" replace />} />
      </Route>
    </Routes>
  )
}

export default App
